import script from "./TaxesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxesModal.vue?vue&type=script&setup=true&lang=js"

import "./TaxesModal.vue?vue&type=style&index=0&id=9b044d40&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b044d40"]])

export default __exports__